import uiRouter from 'angular-ui-router';
import createFormCtrl from './controllers/createImmunizationForm';
import featureListCtrl from './controllers/medicalFeatureList';
import incidentsCtrl from './controllers/incidents/incidents';
import firstAidCtrl from './controllers/incidents/createFirstAidForm';
import referralCtrl from './controllers/incidents/createReferralForm';
import vaccinationCtrl from './controllers/incidents/createVaccinationForm';
import inventoryCtrl from './controllers/inventory/inventory';
import inventoryListCtrl from './controllers/inventory/inventoryList';
import purchaseOrderCtrl from './controllers/inventory/purchaseOrder';
import purchaseListCtrl from './controllers/inventory/purchaseList';
import stockDetailsCtrl from './controllers/inventory/stockDetails';
import userProfileCtrl from './controllers/userProfile';
import userFilterCtrl from './controllers/userFilter';
import medicalProfileCtrl from './controllers/myMedicalProfile';
import createProgrammeCtrl from './controllers/medicalProgramme/createProgramme';
import viewProgrammeCtrl from './controllers/medicalProgramme/viewProgramme';
import programmeConsoleCtrl from './controllers/medicalProgramme/programmeConsole';
import _ from "underscore"
var module = angular.module('MedicalModule', [
        'ui.router'
        //import modules
    ])
    .controller('createFormCtrl', createFormCtrl)
    .controller('featureListCtrl', featureListCtrl)
    .controller('incidentsCtrl', incidentsCtrl)
    .controller('firstAidCtrl', firstAidCtrl)
    .controller('referralCtrl', referralCtrl)
    .controller('vaccinationCtrl', vaccinationCtrl)
    .controller('inventoryCtrl', inventoryCtrl)
    .controller('inventoryListCtrl', inventoryListCtrl)
    .controller('purchaseOrderCtrl', purchaseOrderCtrl)
    .controller('purchaseListCtrl', purchaseListCtrl)
    .controller('stockDetailsCtrl', stockDetailsCtrl)
    .controller('userProfileCtrl', userProfileCtrl)
    .controller('userFilterCtrl', userFilterCtrl)
    .controller('medicalProfileCtrl', medicalProfileCtrl)
    .controller('createProgrammeCtrl', createProgrammeCtrl)
    .controller('viewProgrammeCtrl', viewProgrammeCtrl)
    .controller('programmeConsoleCtrl', programmeConsoleCtrl)

module.constant('MEDICALCONSTANT', {
    API_CREATE_QUESTION:"/v0/medical/immunization/create",
    API_GET_QUESTION:"/v0/medical/immunization/get-question/",
    API_UPDATE_QUESTION:"/v0/medical/immunization/edit",
    API_DELETE_QUESTION:"/v0/medical/immunization/delete/",
    API_SAVE_PURCHASE_ORDER:"/v0/medical/purchase-order/save",
    API_GET_PURCHASE_ORDER:"/v0/medical/purchase-order/list",
    API_UPDATE_PURCHASE_ORDER:"/v0/medical/purchase-order/edit",
    API_GET_INVENTORY_LIST:"/v0/medical/get-inventory",
    API_GET_DELIVERED_DETAILS:"/v0/medical/get-purchase/delivered/",
    API_SAVE_MEDICINE_DETAILS:"/v0/medical/inventory/save",
    API_GET_INVENTORY_PDF:"/v0/medical/inventory/pdf",
    API_GET_SCHOOL_DETAILS: "/v0/teachingPlan/school-details/",
    API_POST_GET_ALL_USERS: "/v0/endorsement/get_all_users",
    API_GET_MEDICAL_PROFILE:"/v0/medical/profile",
    API_GET_MEDICINE_LIST:"/v0/medical/get-medicine-details/",
    API_SAVE_FIRST_AID:"/v0/medical/first-aid/save",
    API_SAVE_REFERRAL_FORM:"/v0/medical/referral-form/save",
    API_GET_VACCINATION_LIST:"/v0/medical/get-vaccine-details/",
    API_SAVE_VACCINATION_DETAILS:"/v0/medical/vaccination/save",
    API_GET_IMMUNIZATION_FORM:"/v0/medical/immunization/get-question",
    API_SEND_IMMUNIZATION_FORM:"/v0/medical/immunization/send-multiple-users",
    API_GET_USER_IMM_FORM:"/v0/medical/immunization/get-reply",
    API_SAVE_USER_REPLY:"/v0/medical/immunization/send-user-reply",
    API_SAVE_PROGRAMME:"/v0/medical/programme/save",
    API_GET_CREATED_PROGRAMME:"/v0/medical/programme/created-list",
    API_GET_CURRENT_DATE: "/v0/server/now",
    API_PUBLISH_PROGRAMME:"/v0/medical/programme/publish/",
    API_GET_ASSIGNED_PROGRAMME:"/v0/medical/programme/list",
    API_ADD_COMMENT:"/v0/medical/programme/add-comment",
    API_ADD_REPORT:"/v0/medical/programme/submit-report"
})

module.config(function($stateProvider, $locationProvider) {
    "ngInject";
});


// WEBPACK FOOTER //
// ./src/app/medical/medicalModule.js